/**
 * Dueño técnico único de CSF y opinión de cumplimiento (Fase 3C).
 * Pantalla canónica: Datos Maestros / Visor SAT → /documentos-fiscales-sat (DocumentosFiscalesSat).
 * El acceso delegado desde Trámites fue retirado del hub; ?tab=sat redirige a la ruta canónica.
 */

export const FISCAL_DOCS_OWNER = {
  moduleId: "visor_sat",
  route: "/documentos-fiscales-sat",
  label: "Documentos fiscales SAT",
  screenTitle: "Constancia CSF y opinión de cumplimiento",
};

/** @deprecated Rutas legacy; redirigen a {@link FISCAL_DOCS_OWNER.route}. */
export const FISCAL_DOCS_DELEGATED_ACCESS = {
  contextId: "tramites",
  route: FISCAL_DOCS_OWNER.route,
  label: "Datos Maestros",
};

/** @param {"owner" | "delegated"} accessMode */
export function isFiscalDocsDelegatedAccess(accessMode) {
  return accessMode === "delegated";
}
